import { useEffect, useState } from "react";
import Layout, { PageHeader } from "../components/Layout";
import SEO from "../components/SEO";
import { Stagger, StaggerItem, Reveal } from "../components/motion";
import { Placeholder } from "../components/StatusBadge";
import { User, LinkedinLogo } from "@phosphor-icons/react";
import { IMAGES } from "../data/images";
import { api } from "../lib/api";

export default function Team() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/team").then((r) => setMembers(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const hasPhotos = members.some((m) => m.image_url);

  return (
    <Layout>
      <SEO title="Our Team" description="The founders and operators behind Eazymuv — an execution-first supply chain company." />
      <PageHeader eyebrow="Our Team" title={<>Operators, not just executives</>} subtitle="The people who run execution and build the technology behind it." image={IMAGES.coldRacks} imageAlt="Eazymuv operations team environment" />
      <section className="max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28">
        {!hasPhotos && !loading && (
          <Reveal><div className="mb-10"><Placeholder label="Team bios & photos managed via admin" /></div></Reveal>
        )}
        {loading ? (
          <div className="font-mono-ez text-sm text-ez-text/50">Loading team…</div>
        ) : (
          <Stagger className="flex flex-wrap justify-center gap-6" data-testid="team-grid">
            {members.map((m) => (
              <StaggerItem key={m.id} className="w-full sm:w-[320px] border border-ez-text p-8 group hover:bg-ez-yellow transition-colors">
                <div className="aspect-square bg-ez-text/5 border border-ez-border flex items-center justify-center mb-6 overflow-hidden">
                  {m.image_url ? (
                    <img src={m.image_url} alt={m.name} className="w-full h-full object-cover" />
                  ) : (
                    <User size={56} weight="thin" className="text-ez-text/30" />
                  )}
                </div>
                <div className="font-mono-ez text-[11px] uppercase tracking-widest text-ez-text/40">{m.tag}</div>
                <div className="font-display text-xl uppercase tracking-tight mt-1">{m.name}</div>
                <div className="text-sm text-ez-text/70 mt-1">{m.role}</div>
                {m.note && <p className="text-xs text-ez-text/50 mt-2">{m.note}</p>}
                {m.linkedin && (
                  <a href={m.linkedin} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1 text-xs font-semibold">
                    <LinkedinLogo size={16} weight="fill" /> LinkedIn
                  </a>
                )}
              </StaggerItem>
            ))}
          </Stagger>
        )}
      </section>
    </Layout>
  );
}
